<template>
  <el-result
    icon="success"
    title="密码修改成功"
    :sub-title="`${countdown}秒后跳转至登录页`"
  >
    <template #extra>
      <el-button key="console" type="primary" @click="handleClick">
        跳转至登录页
      </el-button>
    </template>
  </el-result>
</template>
<script lang="ts" setup>
import { useIntervalFn } from "@vueuse/core"
import { Page } from "@/router/router-enum"
import { notifyParentGo } from "@/utils"

const router = useRouter()

const handleClick = () => {
  // 内嵌iframe中
  if (window.parent != window.self) {
    notifyParentGo(Page.SUPPORT_LOGIN);
    return;
  }
  router.replace(Page.LOGIN);
};

const countdown = ref(5);
useIntervalFn(() => {
  if (--countdown.value == 0) {
    handleClick();
  }
});
</script>
